export type OnboardingKind = 'onboarding' | 'offboarding';
export type OnboardingStatus = 'todo' | 'in_progress' | 'completed';

export const ONBOARDING_KINDS: { value: OnboardingKind; label: string }[] = [
  { value: 'onboarding', label: 'Onboarding' },
  { value: 'offboarding', label: 'Offboarding' },
];

export const ONBOARDING_STATUSES: { value: OnboardingStatus; label: string }[] = [
  { value: 'todo', label: 'To do' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'completed', label: 'Completed' },
];

export const ONBOARDING_KIND_LABEL: Record<OnboardingKind, string> = Object.fromEntries(
  ONBOARDING_KINDS.map((k) => [k.value, k.label]),
) as Record<OnboardingKind, string>;

export const ONBOARDING_STATUS_LABEL: Record<OnboardingStatus, string> = Object.fromEntries(
  ONBOARDING_STATUSES.map((s) => [s.value, s.label]),
) as Record<OnboardingStatus, string>;

export const onboardingKindLabel = (k: string): string =>
  ONBOARDING_KINDS.find((x) => x.value === k)?.label ?? k;

export const onboardingStatusLabel = (s: string): string =>
  ONBOARDING_STATUSES.find((x) => x.value === s)?.label ?? s;

export function onboardingStatusVariant(
  s: string,
): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (s === 'completed') return 'secondary';
  if (s === 'in_progress') return 'default';
  return 'outline';
}
